import {createApp} from 'vue'
import {createRouter, createWebHistory} from 'vue-router'
import App from "./cartes-cadeaux/App";
import {createPinia} from 'pinia'
import routes from "./cartes-cadeaux/routes";
import {addCustomEventListener, setupSmoothScrollTo} from "./cartes-cadeaux/composables/utils";


console.info( 'Gift Card 🎁 JS compiled at %c' + ( new Date(__MIX_COMPILATION_DATE__).toLocaleString('en-CA') ?? 'unknown' ), 'background: green;' );

function onReady() {
    const el = document.querySelector( "#container" );

    const pinia = createPinia()
    const vue   = createApp( App );

    const router = createRouter(
        {
            history : createWebHistory(),
            routes,
            scrollBehavior( to, from, savedPosition ) {
                // always scroll to top
                // cannot do this with CORS
                // window.parent.parent.scrollTo( 0, 0 );

                const message = {
                    type: 'scroll',
                    y: 0

                }

                console.log('posting', message);
                parent.postMessage(message);

                return { top : 0 }
            }
        } );

    vue
        .use( pinia )
        .use( router )
        .provide( 'copydeck', __copydeck__ )
        .provide( 'productGroups', __groups__ )
        .provide( 'lang', __lang__ )
        .provide( 'giftCardAd', __giftCardAd__ )
        .provide( 'giftCardThemes', __giftCardThemes__  )
        .provide( 'productByMail', __by_email__  )
        .mount( el );


    window.postMessage( {
        devtoolsEnabled : true,
        vueDetected     : true
    }, '*' )


    setupSmoothScrollTo();

    /**
     * Newsletter ga event
     */


    addCustomEventListener('#newsletter', 'submit', (e) => {
        console.log('trying to submit newsletter')

        if ( typeof window.gtag !== 'undefined' ) {
            console.log('Sending newsletter event newsletter')
            window.gtag( 'event', 'signed_up_newsletter');
        }
    })
}

document.addEventListener( 'DOMContentLoaded', onReady );
